import { Injectable } from '@angular/core';
import { Router, Params, ActivatedRoute, ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Outlet } from './outlet.model';
import { OutletService } from './outlet.service';


@Injectable()
export class OutletGuard implements Resolve<Outlet> {

  constructor(public router: Router, private outletService: OutletService) { }

  private outletId: string;

  resolve(route: ActivatedRouteSnapshot) {
    this.outletId = route.params['outletId'];
    return this.outletService.getOutletById(this.outletId);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/outlet/outlet.guard.ts